<!--
 * @Author: your name
 * @Date: 2020-07-29 14:01:57
 * @LastEditTime: 2021-03-15 11:02:10
 * @LastEditors: lizhihang
 * @Description: In User Settings Edit
 * @FilePath: \xdap-h5\src\pages\app-engine\app-engine-form\app-engine-form.vue
-->
<template>
  <div ref="appEngineFormDom" class="app-engine-form">
    <form-build-render
      ref="formRender"
      :style="calcStyle"
      :renderSence="'edit'"
      :formItemList="formItemList"
      :formData.sync="formData"
      :globalData="globalData"
      :formRuleConfig="formRuleConfig"
      @scroll.native="handleScroll"
      @formEventEmit="formEventEmit"
    ></form-build-render>
    <div v-if="formOpsList.length > 0 || formBtnList.length > 0" class="form-footer">
      <div v-if="canInputComments" class="form-footer-header">
        <div class="form-footer-idea">
          <cube-textarea
            v-model="approvalComments"
            placeholder="请填写审批意见"
            :indicator="false"
            :maxlength="Infinity"
            class="form-footer-idea--textarea"
          ></cube-textarea>
        </div>
      </div>
      <div ref="footerContent" class="form-footer-content">
        <div v-if="formOpsList.length > 0" class="form-footer--ops">
          <x-svg-icon name="more" @click.native="handleToggle"></x-svg-icon>
          <df-collapse-transition>
            <div v-if="isShowOps" class="ops-content">
              <template v-for="ops in formOpsList">
                <div :key="ops.type" class="ops-content-item" @click="handleOpsClick(ops)">
                  <x-svg-icon :name="ops.icon"></x-svg-icon>
                  <span>{{ ops.text }}</span>
                </div>
              </template>
            </div>
          </df-collapse-transition>
        </div>
        <cube-button
          v-for="formBtn of formBtnList"
          :key="formBtn.type"
          class="form-footer--btn text-ellipsis"
          :light="true"
          :inline="true"
          :primary="formBtn.type !== 'TEMP_SAVE'"
          @click="emitFormOptionButtonWithType(formBtn.type, formBtn)"
        >
          {{ formBtn.text }}
        </cube-button>
      </div>
    </div>

    <approval-history
      v-if="haveProcess"
      ref="approvalHistory"
      :documentId="documentId"
    ></approval-history>
  </div>
</template>

<script>
import apis from '@/api'
import FormBuildEngine from '@/lib/ui/components/form/form-build-engine'
import EditModalButtonTypeMap from './edit-modal-button-type'
import { SET_COMP_PAYLOAD, CLEAR_COMPROUTER_STORE } from '@/store/comp-router.store.js'
import { SET_FORM_CONFIG_BY_FORM_ID, REMOVE_FORM_CONFIG_BY_FORM_ID } from '@/store/form.store.js'
import { mapMutations, mapState } from 'vuex'
import DfCollapseTransition from '@/transitions/collapse-transition/collapse-transition'
import ApprovalHistory from '@/components/approval-history/approval-history'
import FormDataChangeMixin from '@/mixin/form-data-change.mixin'
import ScrollBehaviorMixin from '@/mixin/scroll-behavior.mixin'
import FormRuleExecutorMixin from '@/mixin/form-rule-executor.mixin'

const SystemDefaultButtonList = [
  'CANCEL',
  'CLOSE',
  'SUBMIT',
  'SAVE_DATA_TEMPLATE',
  'TEMP_SAVE',
  'SAVE',
  'RESTART',
  'CLOSE',
  'EDIT',
  'DELETE',
  'OP_SHARE',
  'PRINT',
  'MESSAGE_REMIND',
  'FULL_SCREEN',
  'PREV',
  'NEXT',
  'APPROVE',
  'REJECT',
  'INQUIRE',
  'REASSIGN',
  'ADDONE',
  'REPLY',
  'RESTART',
  'SAVE',
  'APPROVE_HISTORY',
  'FLOW_CHART',
  'WITHDRAW'
]

export default {
  name: 'AppEngineForm',
  components: {
    DfCollapseTransition,
    ApprovalHistory
  },
  mixins: [FormDataChangeMixin, ScrollBehaviorMixin, FormRuleExecutorMixin],
  inject: ['addKeepAlive', 'removeKeepAlive'],
  provide() {
    return {
      $compRouter: {
        push: this.compRouterPush
      }
    }
  },
  data() {
    return {
      optionButtons: [],
      formData: {},
      globalData: {},
      editConfig: {
        xdapFormConfig: {},
        componentStatusList: []
      },
      formItemValidateInfoList: [],
      formId: null,
      documentId: null,
      processId: null,
      taskId: null,
      rowId: null,
      tabId: null,
      tempDocumentId: null,
      dataTemplateId: null, // 数据模板id
      approvalComments: '',
      haveProcess: false,
      processStatus: '',
      formLoadingStack: [],
      isShowOps: false,
      footerContentHeight: 0,
      dataStatisticsList: []
    }
  },
  computed: {
    ...mapState({
      commentPluginStatus: (state) => state.authModule.commentPluginStatus,
      compPayload: (state) => state.compRouterModule.compPayload
    }),

    formItemList() {
      if (
        this.editConfig.xdapFormConfig &&
        this.editConfig.xdapFormConfig.detailPage &&
        this.editConfig.xdapFormConfig.detailPage.formComponents
      ) {
        const formItemList = this.editConfig.xdapFormConfig.detailPage.formComponents
          .map((itemConfig) => {
            const formItemConfig = FormBuildEngine.getInstance().getComponentConfigWithType(
              itemConfig.componentType
            )

            // 配置数据
            const componentStatus = this.editConfig.componentStatusList.find((status) => {
              return status.uuid === itemConfig.uuid
            })

            // 处理表格只读数据
            if (formItemConfig.componentType === 'FORM_WIDGET_TABLE') {
              const tableColumnStatus = componentStatus.tableColumnStatus

              const tableColumn = itemConfig.tableColumn

              tableColumn.map((column) => {
                const columnStatus = tableColumnStatus.find((status) => {
                  return status.uuid === column.uuid
                })

                column.originReadOnly = column.readOnly
                column.enableReadOnlyRule = column.readOnly
                column.enableHiddenRule = column.hidden
                column.enableRequiredRule = column.required

                if (!columnStatus) {
                } else if (columnStatus.status === 'READONLY') {
                  column.readOnly = true
                } else if (columnStatus.status === 'HIDDEN') {
                  column.hidden = true
                } else if (columnStatus.status === 'EDITABLE') {
                  column.readOnly = false
                  column.hidden = false
                }
              })
            }

            const statusConfig = {}
            itemConfig.enableReadOnlyRule = itemConfig.readOnly
            itemConfig.enableHiddenRule = itemConfig.hidden
            itemConfig.enableRequiredRule = itemConfig.required
            if (!componentStatus) {
            } else if (componentStatus.status === 'READONLY') {
              statusConfig.readOnly = true
            } else if (componentStatus.status === 'HIDDEN') {
              statusConfig.hidden = true
            } else if (componentStatus.status === 'EDITABLE') {
              statusConfig.readOnly = false
              statusConfig.hidden = false
            }

            // if (statusConfig.hidden) {
            //   return undefined
            // }

            const itemClass =
              this.selectedComponentConfig && this.selectedComponentConfig.uuid === itemConfig.uuid
                ? 'is-selected'
                : ''
            return {
              ...formItemConfig,
              componentConfig: {
                ...formItemConfig.componentConfig,
                ...itemConfig,
                ...statusConfig
              },
              itemClass: itemClass,
              // 组件校验状态，默认校验通过
              validateInfo: this.formItemValidateInfoList.filter(
                (item) => item.uuid === itemConfig.uuid
              )[0] || {
                uuid: itemConfig.uuid,
                validate: 'validate'
              }
            }
          })
          .filter((item) => !!item)
        return formItemList
      } else {
        return []
      }
    },

    formOpsList() {
      const list = []
      if (this.optionButtons.find((item) => item.buttonCode === 'DELETE')) {
        list.push({
          type: 'DELETE',
          text: '删除',
          icon: 'form-delete'
        })
      }
      if (this.haveProcess) {
        list.push({ text: '审批历史', icon: 'approval-history-icon', type: 'APPROVAL_HISTOREY' })
      }
      if (this.$route.query.documentId && this.commentPluginStatus) {
        list.push({ text: '评论', icon: 'record-comment-icon', type: 'RECORD-COMMENT' })
      }
      if (this.documentId) {
        const messageRemindBtn = this.optionButtons.find(
          (item) => item.buttonCode === 'MESSAGE_REMIND'
        )
        if (messageRemindBtn) {
          messageRemindBtn.type = messageRemindBtn.buttonCode
          messageRemindBtn.text = messageRemindBtn.buttonName
          messageRemindBtn.icon = 'message-remind'
          list.push(messageRemindBtn)
        }
      }
      return list
    },

    formBtnList() {
      if (Array.isArray(this.optionButtons)) {
        return this.optionButtons
          .map((optionBtn) => {
            const btnConfig = EditModalButtonTypeMap[optionBtn.buttonCode]
            if (btnConfig) {
              return {
                ...btnConfig,
                text: optionBtn.buttonName || btnConfig.text,
                type: optionBtn.buttonCode
              }
            } else {
              if (!SystemDefaultButtonList.includes(optionBtn.buttonCode)) {
                return {
                  text: optionBtn.buttonName || btnConfig.text,
                  type: optionBtn.buttonCode
                }
              }
            }
          })
          .filter((item) => !!item)
      } else {
        return []
      }
    },

    calcStyle() {
      return {
        height: this.canInputComments
          ? `calc(100% - 7rem - ${this.footerContentHeight}px)`
          : this.formOpsList.length > 0 || this.formBtnList.length > 0
            ? `calc(100% - ${this.footerContentHeight}px)`
            : 'calc(100%)'
      }
    },

    canInputComments() {
      return this.haveProcess && this.processStatus === 'APPROVING' && !!this.taskId
    },

    computFormFields() {
      const formFields = []
      this.formItemList.forEach((item) => {
        if (item.componentConfig.componentType === 'FORM_WIDGET_TABLE') {
          formFields.push(item.componentConfig)
          item.componentConfig.tableColumn.forEach((column) => {
            const formItemConfig = FormBuildEngine.getInstance().getComponentConfigWithType(
              column.componentType
            )
            formFields.push({
              tableUuid: item.componentConfig.uuid,
              ...formItemConfig.componentConfig,
              ...column
            })
          })
        } else {
          formFields.push(item.componentConfig)
        }
      })
      return formFields
    }
  },
  created() {
    this.initQueryParams()
    this.initFormConfigAndData()
  },
  mounted() {
    // console.log(this.$route.query.documentId)
  },
  activated() {
    this.registerFormContextMethod()
    if (this.compPayload) {
      this.removeKeepAlive(this.$options.name)
      let compPayload = this.compPayload[this.compPayload.activeKey]
      if (compPayload.callback instanceof Function && compPayload.dirty) {
        // 兼容非表单的情况，后续可以考虑均采用这种方式
        compPayload.callback(compPayload.value)
        return
      }
      if (
        !this.compPayload[this.compPayload.activeKey] ||
        !this.compPayload[this.compPayload.activeKey].value
      ) {
        return
      }
      const keys = this.compPayload.activeKey.split('.')
      if (keys.length > 1) {
        // 表格
        if (keys[1] === 'add') {
          if (this.compPayload[this.compPayload.activeKey].value.$deleted) {
            return
          }
          let tableData = this.formData[keys[0]]
          if (!tableData) {
            tableData = []
          }
          tableData.unshift(this.compPayload[this.compPayload.activeKey].value)
          this.$set(this.formData, keys[0], tableData)
          this.formData = { ...this.formData }
          this.clearCompRoterStore(this.compPayload.activeKey)
        } else {
          const index = Number(keys[1])
          const compPayloadValue = this.compPayload[this.compPayload.activeKey].value
          if (compPayloadValue.$deleted) {
            let tableData = this.formData[keys[0]]
            if (tableData) {
              tableData.splice(index, 1)
              this.$set(this.formData, keys[0], tableData)
            }
          } else {
            this.$set(this.formData[keys[0]], index, compPayloadValue)
          }
          this.$set(this.formData, keys[0], this.formData[keys[0]])
          this.formData = { ...this.formData }
          this.clearCompRoterStore(this.compPayload.activeKey)
        }
      } else {
        this.$set(
          this.formData,
          this.compPayload.activeKey,
          this.compPayload[this.compPayload.activeKey].value
        )
        this.formData = { ...this.formData }
        this.clearCompRoterStore(this.compPayload.activeKey)
      }
    }
  },
  beforeDestroy() {
    this.removeFormConfigByFormId(this.formId)
  },
  methods: {
    ...mapMutations('compRouterModule', {
      setCompPayload: SET_COMP_PAYLOAD,
      clearCompRoterStore: CLEAR_COMPROUTER_STORE
    }),
    ...mapMutations('formModule', {
      setFormConfigByFormId: SET_FORM_CONFIG_BY_FORM_ID,
      removeFormConfigByFormId: REMOVE_FORM_CONFIG_BY_FORM_ID
    }),
    calcFooterContentHeight() {
      this.$nextTick(() => {
        this.footerContentHeight = this.$refs.footerContent && this.$refs.footerContent.clientHeight
        console.log(this.footerContentHeight)
      })
    },
    handleToggle() {
      this.isShowOps = !this.isShowOps
    },
    handleOpsClick(ops) {
      if (ops.type === 'DELETE') {
        this.doDelete().then(() => {
          this.isShowOps = false
          this.goBack()
        })
      } else if (ops.type === 'APPROVAL_HISTOREY') {
        this.isShowOps = false
        this.$refs.approvalHistory && this.$refs.approvalHistory.openModal()
      } else if (ops.type === 'MESSAGE_REMIND') {
        this.isShowOps = false
        this.compRouterPush('MessageRemindList', {})
      } else if (ops.type === 'RECORD-COMMENT') {
        this.isShowOps = false
        this.compRouterPush('RecordComment', {})
      }
    },
    compRouterPush(compName, compPayload) {
      compPayload && this.setCompPayload(compPayload) // key widgetConfig value
      this.addKeepAlive(this.$options.name)
      this.$nextTick(() => {
        if (typeof compName === 'object') {
          // 兼容关联表单
          this.$router.push(compName)
        } else {
          this.$router.push({
            name: compName,
            params: {
              id: 'all'
            },
            query: {
              appId: this.$route.query.appId,
              key: compPayload.key,
              formId: this.$route.query.formId,
              documentId: this.$route.query.documentId,
              menuId: this.$route.query.menuId,
              inTable: compPayload.inTable,
              tableUUID: compPayload.tableUUID
            }
          })
        }
      })
    },
    initQueryParams() {
      this.formId = this.$route.query.formId
      this.documentId = this.$route.query.documentId
      this.tabId = this.$route.query.tabId
      this.processId = this.$route.query.processId
      this.taskId = this.$route.query.taskId
      this.dataTemplateId = this.$route.query.dataTemplateId
    },
    initFormConfigAndData() {
      // 此处可以使用并列请求，后续改进，request-plugin支持串行和并行请求
      const request = { ...apis.APP_PAGE.DETAIL_PAGE_CONFIG_BY_ID }
      request.params = {
        formId: this.formId,
        documentId: this.documentId,
        // type: 'EDIT_FORM',
        type: this.$route.query.readOnly ? 'DETAIL_FORM' : 'EDIT_FORM',
        tabId: this.tabId
      }
      this.pushFormLoadingStack('formConfig')
      this.$request(request)
        .asyncThen(
          (res) => {
            this.editConfig = {
              ...this.editConfig,
              xdapFormConfig: res.data.xdapFormConfig,
              componentStatusList: res.data.componentStatusList
            }
            this.setFormConfigByFormId({
              formId: this.formId,
              formConfig: this.editConfig
            })
            this.popFormLoadingStack('formConfig')

            this.initRuleTriggerDeps()
            if (this.documentId) {
              // 编辑
              this.globalData.formId = this.formId
              this.globalData.documentId = this.documentId
              this.initData()
            } else if (this.dataTemplateId) {
              // 从数据模板新增
              this.globalData.formId = this.formId
              this.initTemplateData()
              this.initButtonConfig()
            } else {
              // 如果是新增, 设置默认值
              this.globalData.formId = this.formId
              this.initDefaultData()
              this.initButtonConfig()
            }
            this.storageDataStatisticsComponent(res.data)
          },
          (err) => {
            console.error(err)
            this.popFormLoadingStack('formConfig')
          }
        )
        .asyncErrorCatch((err) => {
          console.error(err)
          this.popFormLoadingStack('formConfig')
        })
    },
    initButtonConfig() {
      let promiseArray = []
      this.$loading.show()
      if (this.haveProcess && this.processStatus !== 'DRAFT') {
        if (this.processStatus === 'REFUSED' || this.processStatus === 'COMPLETED') {
          promiseArray = [this.initFormButtonConfig(), this.initApproveButtonConfig()]
        } else {
          promiseArray = [this.initApproveButtonConfig()]
        }
      } else {
        promiseArray = [this.initFormButtonConfig(), this.initApproveButtonConfig()]
      }
      Promise.all(promiseArray)
        .then((datas) => {
          this.$loading.hide()
          this.optionButtons = datas.flat().reduce((prev, value) => {
            let index = prev.findIndex((item) => item.buttonCode === value.buttonCode)
            if (index === -1) {
              prev.push(value)
            }
            return prev
          }, [])
          // 计算footer-content高度
          this.calcFooterContentHeight()
        })
        .catch(() => {
          this.$loading.hide()
        })
    },
    initFormButtonConfig() {
      return new Promise((resolve, reject) => {
        const formBtnRequest = { ...apis.APP_PAGE.DETAIL_PAGE_GET_FORM_BUTTON }
        formBtnRequest.params = {
          formId: this.formId,
          documentId: this.documentId
        }
        this.$request(formBtnRequest).asyncThen((detailRes) => {
          // this.optionButtons = detailRes.data
          resolve(detailRes.data)
        })
      })
    },
    initApproveButtonConfig() {
      return new Promise((resolve, reject) => {
        const formBtnRequest = { ...apis.APP_PAGE.DETAIL_PAGE_GET_DETAIL_FORM_BUTTON }
        formBtnRequest.params = {
          formId: this.formId,
          documentId: this.documentId
        }
        this.$request(formBtnRequest).asyncThen((detailRes) => {
          // this.optionButtons = detailRes.data
          resolve(detailRes.data)
        })
      })
    },
    pushFormLoadingStack(key) {
      const index = this.formLoadingStack.findIndex((item) => item === key)
      if (index === -1) {
        this.formLoadingStack.push(key)
      }
      if (this.formLoadingStack.length > 0) this.$loading.show()
    },
    popFormLoadingStack(key) {
      const index = this.formLoadingStack.findIndex((item) => item === key)
      if (index !== -1) {
        this.formLoadingStack.splice(index, 1)
      }
      if (this.formLoadingStack.length === 0) {
        // 执行规则引擎
        this.debounceExecuteRuleEngine(
          this.editConfig.xdapFormConfig.detailPage &&
            this.editConfig.xdapFormConfig.detailPage.formRule
        )
      }
      if (this.formLoadingStack.length === 0) this.$loading.hide()
    },
    initData() {
      this.formData = {}
      const detailRequest = {
        ...apis.APP_PAGE.DETAIL_PAGE_GET_BUSINESS_DATA,
        params: {
          formId: this.formId,
          documentId: this.documentId
        }
      }
      this.pushFormLoadingStack('formData')
      this.$request(detailRequest)
        .asyncThen(
          (detailRes) => {
            const formData = detailRes.data.data
            this.haveProcess = detailRes.data.haveProcess
            this.processStatus = detailRes.data.status
            this.taskId = this.taskId || detailRes.data.taskId // 修正从分析表单（日历）进入，无法拿到taskId的情况
            this.formData = {
              ...this.formData,
              ...formData
            }
            this.initDataStatistics()
            this.setSourceDataStr(this.formData)
            this.rowId = detailRes.data.rowId
            this.globalData.rowId = this.rowId
            this.globalData.formData = this.formData
            this.popFormLoadingStack('formData')
            this.triggerRule()
            this.initButtonConfig()
          },
          () => {
            this.popFormLoadingStack('formData')
          }
        )
        .asyncErrorCatch(() => {
          this.popFormLoadingStack('formData')
        })

      // 初始化表单数据
      setTimeout(() => {
        const tableUuids = this.formItemList
          .map((formItem) => {
            if (formItem.componentType === 'FORM_WIDGET_TABLE') {
              return formItem.componentConfig.uuid
            } else {
              return undefined
            }
          })
          .filter((uuid) => uuid)

        tableUuids.forEach((uuid) => {
          const detailTableRequest = { ...apis.APP_PAGE.DETAIL_PAGE_GET_TABLE_BUSINESS_DATA }
          detailTableRequest.params = {
            formId: this.formId,
            documentId: this.documentId,
            tableUuid: uuid
          }
          this.pushFormLoadingStack('tableData' + uuid)
          this.$request(detailTableRequest)
            .asyncThen(
              (detailRes) => {
                const tableData = detailRes.data.tableData
                this.formData = {
                  ...this.formData,
                  ...tableData
                }
                this.initDataStatistics()
                this.setSourceDataStr(this.formData)
                this.globalData.formData = this.formData
                this.popFormLoadingStack('tableData' + uuid)
              },
              () => {
                this.popFormLoadingStack('tableData' + uuid)
              }
            )
            .asyncErrorCatch(() => {
              this.popFormLoadingStack('tableData' + uuid)
            })
        })
      })
    },
    initTemplateData() {
      this.formData = {}
      const detailRequest = {
        ...apis.APP_PAGE.DETAIL_PAGE_GET_TEMPLATE_DATA,
        params: {
          dataModuleId: this.dataTemplateId
        }
      }
      this.pushFormLoadingStack('templateData')
      this.$request(detailRequest)
        .asyncThen(
          (detailRes) => {
            const formData = detailRes.data.moduleData
            this.formData = {
              ...this.formData,
              ...formData
            }
            this.initDataStatistics()
            // 单据号组件值清空，隐藏的组件的值清空 ---------------------------------- start
            this.editConfig.componentStatusList.forEach((item) => {
              if (item.componentType === 'FORM_DOCUMENT_NUMBER' || item.status === 'HIDDEN') {
                delete this.formData[item.uuid]
              }
            })
            // 单据号组件值清空，隐藏的组件的值清空 ---------------------------------- end
            const tableUuids = this.editConfig.componentStatusList
              .map((formItem) => {
                if (
                  formItem.componentType === 'FORM_WIDGET_TABLE' &&
                  formItem.status !== 'HIDDEN'
                ) {
                  return formItem.uuid
                } else {
                  return undefined
                }
              })
              .filter((uuid) => uuid)
            tableUuids.forEach((uuid) => {
              // 单据号组件值清空，隐藏的组件的值清空 ---------------------------------- start
              const componentStatusList = this.editConfig.componentStatusList.filter(
                (item) => item.uuid === uuid
              )
              if (
                componentStatusList[0].tableColumnStatus &&
                componentStatusList[0].tableColumnStatus.length > 0
              ) {
                componentStatusList[0].tableColumnStatus.forEach((item) => {
                  if (item.componentType === 'FORM_DOCUMENT_NUMBER' || item.status === 'HIDDEN') {
                    ;(this.formData[uuid] || []).forEach((tableItem, index) => {
                      delete this.formData[uuid][index][item.uuid]
                    })
                  }
                })
              }
              // 单据号组件值清空，隐藏的组件的值清空 ---------------------------------- end
            })
            this.setSourceDataStr(this.formData)
            this.popFormLoadingStack('templateData')
            this.triggerRule()
          },
          () => {
            this.popFormLoadingStack('templateData')
          }
        )
        .asyncErrorCatch(() => {
          this.popFormLoadingStack('templateData')
        })
    },
    initDefaultData() {
      if (Array.isArray(this.formItemList)) {
        this.formItemList.forEach((formItem) => {
          if (
            formItem.componentConfig.defaultValue ||
            formItem.componentConfig[formItem.componentConfig.customDefaultKey]
          ) {
            if (
              formItem.componentConfig.methods &&
              formItem.componentConfig.methods.lcConvertDefaultValue
            ) {
              this.formData[
                formItem.componentConfig.uuid
              ] = formItem.componentConfig.methods.lcConvertDefaultValue(formItem.componentConfig)
            } else {
              this.formData[formItem.componentConfig.uuid] = formItem.componentConfig.defaultValue
            }
          }
        })
      }
      this.setSourceDataStr(this.formData)
      this.initDataStatistics()
      this.triggerRule()
    },
    emitFormOptionButtonWithType(type, btn) {
      // 找到对应的按钮
      if (typeof type === 'string') {
        // 找到当前配置
        let buttonConfig = {}
        let executeFunction
        if (!SystemDefaultButtonList.includes(type)) {
          btn.action = []
          btn.event = 'DO_APPROVE'
          btn.executeFunction = 'doCustomProcessEvent'
          btn.needValidate = true
          buttonConfig = btn
          executeFunction = this[buttonConfig.executeFunction]
        } else {
          buttonConfig = EditModalButtonTypeMap[type]
          executeFunction = this[buttonConfig.executeFunction]
        }

        const result = executeFunction(buttonConfig)

        if (result instanceof Promise) {
          result.then(() => {
            if (!buttonConfig.noBack) {
              this.goBack()
            }
            // this.$emit(buttonConfig.event)
            // this.callback(this.formParamKey, 'EDITFORM', buttonConfig.event)
          })
        } else {
          // this.$emit(buttonConfig.event)
          // this.callback(this.formParamKey, 'EDITFORM', buttonConfig.event)
        }
      }
    },
    goBack() {
      this.sourceDataStr = JSON.stringify(this.formData)
      this.$router.go(-1)
    },
    initDataStatistics() {
      this.globalData = Object.assign({}, this.globalData, { ready: false })
      setTimeout(() => {
        this.globalData = Object.assign({}, this.globalData, { ready: true })
      }, 600)
    },
    filterDataStatistics(formData) {
      // 过滤data中的数据统计组件
      if (this.dataStatisticsList && this.dataStatisticsList.length > 0) {
        this.dataStatisticsList.forEach((item) => {
          if (formData.hasOwnProperty(item)) {
            delete formData[item]
          }
        })
      }
    },
    storageDataStatisticsComponent(data) {
      // 记录表单内的数据统计组件
      this.dataStatisticsList = []
      setTimeout(() => {
        if (data.componentStatusList) {
          this.dataStatisticsList = data.componentStatusList
            .filter((com) => com.componentType === 'FORM_DATA_STATISTICS')
            .map((item) => item.uuid)
        }
      })
    },
    submitFormData() {
      return new Promise((resolve, reject) => {
        this.$refs.formRender.validate((validate, error) => {
          if (validate) {
            const request = { ...apis.APP_PAGE.DETAIL_PAGE_PROCESS_SUBMIT }

            // 分离表单数据和表格数据
            const tableUuids = this.formItemList
              .map((formItem) => {
                if (formItem.componentType === 'FORM_WIDGET_TABLE') {
                  return formItem.componentConfig.uuid
                } else {
                  return undefined
                }
              })
              .filter((uuid) => uuid)

            const tableData = {}
            const formData = JSON.parse(JSON.stringify(this.formData))

            tableUuids.forEach((uuid) => {
              tableData[uuid] = formData[uuid]
              delete formData[uuid]
            })

            this.filterDataStatistics(formData)

            request.params = {
              formId: this.formId,
              documentId: this.documentId,
              rowId: this.rowId,
              data: formData,
              tableData: tableData
            }
            this.$loading.show()
            this.$request(request)
              .asyncThen(
                (res) => {
                  this.$loading.hide()
                  this.initDataStatistics()
                  resolve()
                },
                (error) => {
                  this.$loading.hide()
                  reject(error)
                }
              )
              .asyncErrorCatch((error) => {
                this.$loading.hide()
                reject(error)
              })
          } else {
            this.scrollToError()
            reject(error)
          }
        })
      })
    },
    mergeProcessParams(userIds) {
      // 分离表单数据和表格数据
      const tableUuids = this.formItemList
        .map((formItem) => {
          if (formItem.componentType === 'FORM_WIDGET_TABLE') {
            return formItem.componentConfig.uuid
          } else {
            return undefined
          }
        })
        .filter((uuid) => uuid)

      const tableData = {}
      const formData = JSON.parse(JSON.stringify(this.formData))

      tableUuids.forEach((uuid) => {
        tableData[uuid] = formData[uuid]
        delete formData[uuid]
      })
      this.filterDataStatistics(formData)
      const params = {
        formId: this.formId,
        documentId: this.documentId,
        processId: this.processId,
        rowId: this.rowId,
        taskId: this.taskId,
        comment: this.approvalComments,
        data: formData,
        tableData: tableData
      }

      if (userIds && userIds.length > 0) {
        params.reassignUser = userIds.join ? userIds.join(',') : userIds
      }

      return params
    },
    // 征询
    doInquire() {
      return new Promise((resolve, reject) => {
        const vm = this
        this.compRouterPush('FormPeopleSelect', {
          key: 'person-select',
          widgetConfig: {
            chooseType: 'SINGLE'
          },
          value: [],
          callback: (selectedArray) => {
            if (!selectedArray || selectedArray.length === 0) {
              vm.$message({
                type: 'error',
                message: `请先选择征询人`
              })
            } else {
              const request = {
                ...apis.APP_PAGE.DO_INQUIRE,
                params: vm.mergeProcessParams(
                  selectedArray.map((user) => {
                    return user.id
                  })
                )
              }
              this.$loading.show()
              vm.$request(request)
                .asyncThen(
                  (resp) => {
                    this.$loading.hide()
                    resolve()
                  },
                  (err) => {
                    this.$loading.hide()
                    reject(err)
                  }
                )
                .asyncErrorCatch((err) => {
                  this.$loading.hide()
                  reject(err)
                })
            }
          }
        })
      })
    },

    // 转交
    doReassign() {
      return new Promise((resolve, reject) => {
        const vm = this
        this.compRouterPush('FormPeopleSelect', {
          key: 'person-select',
          widgetConfig: {
            chooseType: 'SINGLE'
          },
          value: [],
          callback: (selectedArray) => {
            if (!selectedArray || selectedArray.length === 0) {
              vm.$message({
                type: 'error',
                message: `请先选择转发人`
              })
            } else {
              const request = {
                ...apis.APP_PAGE.DO_REASSIGN,
                params: vm.mergeProcessParams(
                  selectedArray.map((user) => {
                    return user.id
                  })
                )
              }
              this.$loading.show()
              vm.$request(request)
                .asyncThen(
                  (resp) => {
                    this.$loading.hide()
                    resolve()
                  },
                  (err) => {
                    this.$loading.hide()
                    reject(err)
                  }
                )
                .asyncErrorCatch((err) => {
                  this.$loading.hide()
                  reject(err)
                })
            }
          }
        })
      })
    },

    // 加签
    doAddOne() {
      return new Promise((resolve, reject) => {
        const vm = this
        this.compRouterPush('FormPeopleSelect', {
          key: 'person-select',
          widgetConfig: {
            chooseType: 'SINGLE'
          },
          value: [],
          callback: (selectedArray) => {
            if (!selectedArray || selectedArray.length === 0) {
              vm.$message({
                type: 'error',
                message: `请先选择加签人`
              })
            } else {
              const request = {
                ...apis.APP_PAGE.DO_ADDONE,
                params: vm.mergeProcessParams(
                  selectedArray.map((user) => {
                    return user.id
                  })
                )
              }
              this.$loading.show()
              vm.$request(request)
                .asyncThen(
                  (resp) => {
                    this.$loading.hide()
                    resolve()
                  },
                  (err) => {
                    this.$loading.hide()
                    reject(err)
                  }
                )
                .asyncErrorCatch((err) => {
                  this.$loading.hide()
                  reject(err)
                })
            }
          }
        })
      })
    },

    // 回复
    doReply() {
      return new Promise((resolve, reject) => {
        const request = { ...apis.APP_PAGE.DO_REPLY }
        request.params = this.mergeProcessParams()
        this.$loading.show()
        this.$request(request)
          .asyncThen(
            (res) => {
              this.$loading.hide()
              resolve()
            },
            (error) => {
              this.$loading.hide()
              reject(error)
            }
          )
          .asyncErrorCatch((error) => {
            this.$loading.hide()
            reject(error)
          })
      })
    },
    doApprove() {
      return new Promise((resolve, reject) => {
        this.$refs.formRender.validate((validate, error) => {
          if (validate) {
            const request = {
              ...apis.APP_PAGE.DO_APPROVE,
              params: this.mergeProcessParams()
            }
            request.params.buttonCode = 'APPROVE'
            this.$loading.show()
            this.$request(request)
              .asyncThen(
                (res) => {
                  this.$loading.hide()
                  resolve()
                },
                (error) => {
                  this.$loading.hide()
                  reject(error)
                }
              )
              .asyncErrorCatch((error) => {
                this.$loading.hide()
                reject(error)
              })
          } else {
            this.scrollToError()
            reject(error)
          }
        })
      })
    },
    // 自定义按钮
    doCustomProcessEvent(buttonConfig) {
      return new Promise((resolve, reject) => {
        this.$refs.formRender.validate((validate, error) => {
          if (validate) {
            const request = {
              ...apis.APP_PAGE.DO_CUSTOM_PROCESS,
              params: this.mergeProcessParams()
            }
            request.params.buttonCode = buttonConfig.type
            request.params.buttonName = buttonConfig.text
            this.$loading.show()
            this.$request(request)
              .asyncThen(
                (res) => {
                  this.$loading.hide()
                  resolve()
                },
                (error) => {
                  this.$loading.hide()
                  reject(error)
                }
              )
              .asyncErrorCatch((error) => {
                this.$loading.hide()
                reject(error)
              })
          } else {
            this.scrollToError()
            reject(error)
          }
        })
      })
    },
    doDelete() {
      return new Promise((resolve, reject) => {
        this.$confirm({
          message: '删除数据后不可恢复，是否确定删除？',
          okConfig: {
            onOk: () => {
              return this.deleteFormApi().then(
                () => {
                  resolve()
                },
                (error) => {
                  reject(error)
                }
              )
            }
          },
          cancelConfig: {
            onCancel: () => {}
          }
        })
      })
    },
    deleteFormApi() {
      return new Promise((resolve, reject) => {
        // this.deleteLoading = true
        const request = { ...apis.APP_PAGE.DO_DELETE }
        request.params = {
          formId: this.formId,
          documentId: this.documentId
        }
        this.$loading.show()
        this.$request(request)
          .asyncThen(
            (res) => {
              this.$loading.hide()
              // this.deleteLoading = false
              resolve()
            },
            (error) => {
              this.$loading.hide()
              // this.deleteLoading = false
              reject(error)
            }
          )
          .asyncErrorCatch((error) => {
            this.$loading.hide()
            // this.deleteLoading = false
            reject(error)
          })
      })
    },
    doReject() {
      return new Promise((resolve, reject) => {
        this.$refs.formRender.validate((validate, error) => {
          if (validate) {
            const request = {
              ...apis.APP_PAGE.DO_REJECT,
              params: this.mergeProcessParams()
            }
            this.$loading.show()
            this.$request(request)
              .asyncThen(
                (res) => {
                  this.$loading.hide()
                  resolve()
                },
                (error) => {
                  this.$loading.hide()
                  reject(error)
                }
              )
              .asyncErrorCatch((error) => {
                this.$loading.hide()
                reject(error)
              })
          } else {
            this.scrollToError()
            reject(error)
          }
        })
      })
    },
    doWithDraw() {
      return new Promise((resolve, reject) => {
        this.$refs.formRender.validate((validate, error) => {
          if (validate) {
            const request = {
              ...apis.APP_PAGE.DO_WITHDRAW,
              params: this.mergeProcessParams()
            }
            this.$loading.show()
            this.$request(request)
              .asyncThen(
                (res) => {
                  this.$loading.hide()
                  resolve()
                },
                (error) => {
                  this.$loading.hide()
                  reject(error)
                }
              )
              .asyncErrorCatch((error) => {
                this.$loading.hide()
                reject(error)
              })
          } else {
            this.scrollToError()
            reject(error)
          }
        })
      })
    },
    saveFormData() {
      return new Promise((resolve, reject) => {
        this.$refs.formRender.validate((validate, error) => {
          if (validate) {
            // 分离表单数据和表格数据
            const tableUuids = this.formItemList
              .map((formItem) => {
                if (formItem.componentType === 'FORM_WIDGET_TABLE') {
                  return formItem.componentConfig.uuid
                } else {
                  return undefined
                }
              })
              .filter((uuid) => uuid)

            const tableData = {}
            const formData = JSON.parse(JSON.stringify(this.formData))

            tableUuids.forEach((uuid) => {
              tableData[uuid] = formData[uuid]
              delete formData[uuid]
            })
            this.filterDataStatistics(formData)
            const request = { ...apis.APP_PAGE.DETAIL_PAGE_SUBMIT_BUSINESS_DATA }
            request.params = {
              formId: this.formId,
              documentId: this.documentId,
              rowId: this.rowId,
              data: formData,
              tableData: tableData
            }
            this.$loading.show()
            this.$request(request)
              .asyncThen(
                (res) => {
                  this.$loading.hide()
                  this.initDataStatistics()
                  resolve()
                },
                (error) => {
                  this.$loading.hide()
                  reject(error)
                }
              )
              .asyncErrorCatch((error) => {
                this.$loading.hide()
                reject(error)
              })
          } else {
            this.scrollToError()
            reject(error)
          }
        })
      })
    },
    tempSaveFormData() {
      return new Promise((resolve, reject) => {
        // 分离表单数据和表格数据
        const tableUuids = this.formItemList
          .map((formItem) => {
            if (formItem.componentType === 'FORM_WIDGET_TABLE') {
              return formItem.componentConfig.uuid
            } else {
              return undefined
            }
          })
          .filter((uuid) => uuid)

        const tableData = {}
        const formData = JSON.parse(JSON.stringify(this.formData))

        tableUuids.forEach((uuid) => {
          tableData[uuid] = formData[uuid]
          delete formData[uuid]
        })
        this.filterDataStatistics(formData)

        const request = { ...apis.APP_PAGE.DETAIL_PAGE_TEMPSAVE_BUSINESS_DATA }
        request.params = {
          formId: this.formId,
          documentId: this.documentId || this.tempDocumentId,
          rowId: this.rowId,
          data: formData,
          tableData: tableData
        }
        this.$loading.show()
        this.$request(request)
          .asyncThen(
            (res) => {
              this.$loading.hide()
              this.rowId = res.data.rowId
              this.documentId = res.data.documentId
              this.sourceDataStr = JSON.stringify(this.formData)
              this.initDataStatistics()
              resolve()
            },
            (error) => {
              this.$loading.hide()
              reject(error)
            }
          )
          .asyncErrorCatch((error) => {
            this.$loading.hide()
            reject(error)
          })
      })
    },
    doRestart() {
      return new Promise((resolve, reject) => {
        this.$refs.formRender.validate((validate, error) => {
          if (validate) {
            const request = { ...apis.APP_PAGE.DO_RESTART }
            // 分离表单数据和表格数据
            const tableUuids = this.formItemList
              .map((formItem) => {
                if (formItem.componentType === 'FORM_WIDGET_TABLE') {
                  return formItem.componentConfig.uuid
                } else {
                  return undefined
                }
              })
              .filter((uuid) => uuid)

            const tableData = {}
            const formData = JSON.parse(JSON.stringify(this.formData))

            tableUuids.forEach((uuid) => {
              tableData[uuid] = formData[uuid]
              delete formData[uuid]
            })
            this.filterDataStatistics(formData)
            request.params = {
              formId: this.formId,
              documentId: this.documentId,
              processId: this.processId,
              rowId: this.rowId,
              taskId: this.taskId,
              comment: this.approvalComments,
              data: formData,
              tableData: tableData
            }
            this.$loading.show()
            this.$request(request)
              .asyncThen(
                (res) => {
                  this.$loading.hide()
                  resolve()
                },
                (error) => {
                  this.$loading.hide()
                  reject(error)
                }
              )
              .asyncErrorCatch((error) => {
                this.$loading.hide()
                reject(error)
              })
          } else {
            this.scrollToError()
            reject(error)
          }
        })
      })
    },
    scrollToError() {
      setTimeout(() => {
        const isError = this.$refs.appEngineFormDom.getElementsByClassName('is-error')
        const dom = isError[0].parentElement
        dom.scrollIntoView({
          // 滚动到指定节点
          block: 'start', // 值有start,center,end，nearest，当前显示在视图区域开始
          behavior: 'smooth' // 值有auto、instant,smooth，缓动动画（当前是慢速的）
        })
      }, 100)
    },
    handleRouteLeave(type) {
      const _this = this
      return new Promise((resolve, reject) => {
        if (type === 'SAVE') {
          _this.$confirm({
            message: '是否需要提交或保存修改?',
            okConfig: {
              onOk() {
                _this
                  .saveFormData()
                  .then(() => {
                    resolve()
                  })
                  .catch((err) => {
                    reject(err)
                  })
              }
            },
            cancelConfig: {
              onCancel() {
                resolve()
              }
            }
          })
        } else if (type === 'SUBMIT') {
          _this.$confirm({
            message: '是否需要提交或保存修改?',
            okConfig: {
              onOk() {
                _this
                  .submitFormData()
                  .then(() => {
                    resolve()
                  })
                  .catch((err) => {
                    reject(err)
                  })
              }
            },
            cancelConfig: {
              onCancel() {
                resolve()
              }
            }
          })
        } else {
          resolve()
        }
      })
    },
    scrollToY(y) {
      this.$refs.formRender.$el.scrollTop = y
    }
  }
}
</script>

<style lang="scss">
.app-engine-form {
  position: relative;
  height: 100%;
  .form-build-render {
    overflow-y: auto;
    overflow-x: hidden;
    background-color: $--app-body-bgColor;
    // 这一行可以避免表单项在有动画触发时消失，原因未知
    -webkit-overflow-scrolling: touch;
  }
  .form-footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    background-color: $--app-light-color;
    border-top: 1px solid $--app-body-bgColor;
    .form-footer-header {
      padding: 0.5rem;
      .form-footer-idea--textarea {
        min-height: 6.14rem;
        max-height: 6.14rem;
        &.cube-textarea-wrapper::after {
          border: 0;
        }
      }
    }
    .form-footer-content {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: flex-end;
      .form-footer--ops {
        position: relative;
        display: flex;
        justify-content: flex-start;
        flex: 1;
        color: $--app-primary-color;
        margin-left: 1.14rem;
        margin-bottom: 0.57rem;
        height: 2.285rem;
        .x-svg-icon {
          display: flex;
          align-items: center;
        }
        .ops-content {
          display: flex;
          flex-direction: column;
          position: absolute;
          bottom: 100%;
          left: 0;
          width: 7rem;
          border-radius: $--app-base-border-radius;
          background-color: $--app-box-bgColor;
          z-index: 100;
          box-shadow: $--app-box-shadow;
          box-sizing: border-box;
          .ops-content-item {
            flex: 1;
            display: flex;
            align-items: center;
            height: 2.5rem;
            padding: 0.285rem;
            > span {
              font-size: $--app-base-font-size;
              flex: 1;
              margin: 0 0.285rem;
            }
          }
        }
      }
      .form-footer--btn {
        max-width: 50vw;
        margin-top: 0.28rem;
        margin-bottom: 0.28rem;
      }
    }
    .cube-btn {
      margin-right: 1.142rem;
      padding: 0 1rem;
      height: 2.285rem;
    }
  }
}
</style>
